var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h3',{staticClass:"triplog-header"},[_vm._v(" "+_vm._s(_vm.getDateDescription(_vm.date.getDay()))+" "+_vm._s(_vm._f("formatDate")(_vm.date))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }